// extracted by mini-css-extract-plugin
export default {"detailsField":"open_vacancy-module___detailsField___f45bf5d7"};